import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import Image, { ImageProps } from 'next/image';
import { useCallback, useState } from 'react';

import { ArticleImageFragmentFragment, ImageFragmentFragment } from '../../__generated__/graphql';
import { WithoutTypename } from '../../types';

import style from './app-image.module.css';

interface AppImageProps {
  className?: string;
  fallbackHeight: number;
  fallbackWidth: number;
  // omitting the typename to avoid type errors
  image: WithoutTypename<ArticleImageFragmentFragment> | WithoutTypename<ImageFragmentFragment>;
  withBorder?: boolean;
}
type NextImageProps = Omit<ImageProps, 'alt' | 'className' | 'height' | 'src' | 'width'>;

const AppImage = ({
  className,
  fallbackHeight,
  fallbackWidth,
  image,
  withBorder,
  ...nextImageProps
}: AppImageProps & NextImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const thumbnail = image.node.mediaDetails?.sizes?.find(
    s => s?.name === 'thumbnail',
  );

  const thumbnailSrc = isLoaded ? null : thumbnail?.sourceUrl;

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
  }, []);

  return (
    <Image
      alt={image.node.altText ?? ''}
      className={classNames(
        style.appImage,
        { [style.appImageWithBorder]: withBorder },
        className,
      )}
      height={image.node.mediaDetails?.height ?? fallbackHeight}
      onLoad={handleLoad}
      sizes="(width <= 375px) 300px, (width <= 425px) 400px, (width < 1280px) 600px, 800px"
      src={image.node.link ?? ''}
      style={thumbnailSrc
        ? {
          backgroundImage: `url(${thumbnailSrc})`,
          backgroundSize: 'cover',
        }
        : undefined}
      width={image.node.mediaDetails?.width ?? fallbackWidth}
      {...nextImageProps}
    />
  );
};

export default AppImage;
